import React from "react";

// components

import CardUpgrade from "components/Cards/CardUpgrade.js";

export default function Upgrade() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-full px-4">
          <CardUpgrade />
        </div>
      </div>
    </>
  )
}